import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SiteProvider } from "./contexts/SiteContext";
import { AdminProvider } from "./contexts/AdminContext";
import { CurrencyProvider } from "./contexts/CurrencyContext";
import Home from "./pages/Home";
import StudentVideo from "./pages/StudentVideo";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  useEffect(() => {
    document.documentElement.style.colorScheme = "light";
    document.documentElement.classList.remove("dark");
    document.body.style.backgroundColor = "#F4F1EA";
  }, []);

  return (
    <div className="App" style={{ backgroundColor: "#F4F1EA", minHeight: "100vh" }}>
      <BrowserRouter>
        <AdminProvider>
          <SiteProvider>
            <CurrencyProvider>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/v/:slug" element={<StudentVideo />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute>
                      <AdminDashboard />
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </CurrencyProvider>
          </SiteProvider>
        </AdminProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
